import React, { useContext } from 'react';
import { UserContext } from '../contexts/UserContext';
import { Spinner } from './Spinner';
import VehicleInventory from './VehicleInventory';

function Home() {
  const { token, user } = useContext(UserContext);

  return (
    <>
      {!user && !token ? (
        <div className="middle">
          <Spinner></Spinner>
        </div>
      ) : (
        <>
          <VehicleInventory />
        </>
      )}
    </>
  );
}

export default Home;
